import { UiTheme } from '../../theme'

export default (theme: UiTheme) => ({
  base: {
    marginBottom: theme.settings.spacing.large,
    background: 'none',
    border: 'none',
  },
  variants: {
    regular: {
      borderBottom: `1px solid ${theme.colors.borders.regular}`,
    },
    primary: {
      borderBottom: `1px solid ${theme.colors.borders.primary}`,
    },
    dim: {
      borderBottom: `1px solid ${theme.colors.borders.dim}`,
    },
  },
  tight: {
    marginBottom: theme.settings.spacing.small,
  },
  flush: {
    marginBottom: 0,
  },
  strong: {
    borderBottomWidth: '3px',
  },
})
